import instance from "../utils/network";

const url = process.env.REACT_APP_WEB_AUTH_HOST;

export enum PubOwnerRole {
  OWNER = "OWNER", // 소유자
  MANAGER = "MANAGER", // 모든 토너먼트 접근 가능
  STAFF = "STAFF", // 특정 토너먼트 접근 가능
}

export enum PubPermission {
  TOURNAMENT_EDIT = "TOURNAMENT_EDIT", // 토너먼트 수정 권한
  TOURNAMENT_TIMER = "TOURNAMENT_TIMER", // 토너먼트 타이머 관련 권한
  MEMBER = "MEMBER", // 회원 관리 권한
  TOURNAMENT_PRIZE = "TOURNAMENT_PRIZE", // 시상 권한
  TOURNAMENT_SITOUT = "TOURNAMENT_SITOUT", // 토너먼트 싯아웃, 싯아웃 롤백 권한
}

export enum PubOwnerDomain {
  TOURNAMENT = "TOURNAMENT", // 토너먼트 페이지
  RESERVATION = "RESERVATION", // 예약 페이지
  MANAGEMENT = "MANAGEMENT", // 펍 관리 페이지
  MARKETING = "MARKETING", // 마케팅 서비스 페이지
  SETTLEMENT = "SETTLEMENT", // 정산 페이지
  MEMBER = "MEMBER", // 회원 페이지
  EVENT = "EVENT", // 이벤트 페이지 -> 추후 사용 예정
  TICKET = "TICKET",
}

export interface PubOwnerDto {
  id: number;
  pubId: number;
  userId: number;
  role: PubOwnerRole;
  tournamentIds: number[];
  permissions: PubPermission[];
  domain: PubOwnerDomain[];
}

export interface PubOwnerResponse {
  id: number;
  pubId: number;
  userId: number;
  username: string;
  nickname: string;
  phoneNumber: string;
  role: PubOwnerRole;
  createdAt: Date;
  permissions: PubPermission[];
  tournamentIds: number[];
  isActive: boolean;
  domains: PubOwnerDomain[];
}

export interface PubOwnerAccessRequest {
  pubId: number;
  userId: number;
  role: PubOwnerRole;
  tournamentIds: number[];
  permissions: PubPermission[];
  domains: PubOwnerDomain[];
}

export interface PubImage {
  id: number;
  imageUrl: string;
}

export interface PubFacilities {
  id: number;
  type: string;
  name: string;
}
export interface CafeSellerMetadataUpdateRequest {
  cafeId: number;
  directions: string;
  facilities: string[];
  informationUse: string;
  naverPlaceUrl: string;
}

export interface PubEvent {
  imageUrl: string;
}

export enum PubType {
  NORMAL = "NORMAL",
  PREMIUM = "PREMIUM",
  VIP = "VIP",
  FRANCHISE = "FRANCHISE",
  RUNNER = "RUNNER",
}
export interface PubDetail {
  id: number;
  pubName: string;
  pubType: PubType;
  cafeName: string;
  newAddress: string;
  vcn: string;
  detailAddress: string;
  ownerName: string;
  phoneNumber: string;
  directions: string;
  informationUse: string;
  naverPlaceUrl: string;
  images: PubImage[];
  facilities: string[];
  events: PubEvent[];
  blindUp: number;
  blindUpMax: number;
  buyIn: number;
  buyInMax: number;
  prize: number;
  prizeMax: number;
  lon: number;
  lat: number;
  gameTypes: string[];
  employerId: string;
  pubOwnerId: number;
  role: PubOwnerRole;
  tournamentIds: number[];
  permissions: PubPermission[];
  domains: PubOwnerDomain[];
}

export interface PubDetailInfoRequest {
  cafeId: number;
  blindUp: number;
  blindUpMax: number;
  buyIn: number;
  buyInMax: number;
  prize: number;
  prizeMax: number;
}

export interface PubStaffResponse {
  userId: number;
  pubId: number;
  id: number;
  nickname: string;
  username: string;
}

export interface PubLikeResponse {
  count: number;
  users: string[];
}

export interface PubStaffReqeust {
  pubId: number;
  nickname: string;
}

export function getPubStaffList(pubId: number): Promise<PubStaffResponse[]> {
  return instance.get(`${url}/seller/pub/staff/${pubId}`);
}

export function addPubStaff(
  request: PubStaffReqeust,
): Promise<{ code: number; message: string }> {
  return instance.post(`${url}/seller/pub/staff`, request);
}

export function deletePubStaff(
  staffId: number,
): Promise<{ code: number; message: string }> {
  return instance.delete(`${url}/seller/pub/staff/${staffId}`);
}

export function sellerPub(pubId: number): Promise<PubDetail> {
  return instance.get(`${url}/seller/pub/seller/${pubId}`);
}

export function getPubLikes(id: number): Promise<PubLikeResponse> {
  return instance.get(`${url}/seller/pub/likes/${id}`);
}

export function updateSellerPub(request: CafeSellerMetadataUpdateRequest) {
  return instance.put(
    `${url}/seller/pub/update-metadata-seller/${request.cafeId}`,
    request,
  );
}
export function updateDetailSellerPub(request: PubDetailInfoRequest) {
  return instance.put(
    `${url}/seller/pub/update-detail-seller/${request.cafeId}`,
    request,
  );
}
export function pushSellerPubImage(
  id: number,
  formData: FormData,
): Promise<{ code: number; message: string }> {
  return instance.put(`${url}/seller/pub/push-image/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteSellerPubImage(id: number, imageUrl: string) {
  return instance.delete(`${url}/seller/pub/delete-image/${id}`, {
    params: {
      imageUrl,
    },
  });
}

export function pushSellerPubEventImage(
  id: number,
  formData: FormData,
): Promise<{ code: number; message: string }> {
  return instance.put(`${url}/seller/pub/event-image/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteSellerPubEventImage(id: number, imageUrl: string) {
  return instance.delete(`${url}/seller/pub/event-image/${id}`, {
    params: {
      imageUrl,
    },
  });
}

export function getPubOwnersApi(pubId: number): Promise<PubOwnerResponse[]> {
  return instance.get(`/seller/pub/owner/${pubId}`);
}

export function addPubOwnerApi(
  request: PubOwnerAccessRequest,
): Promise<{ code: number; message: string }> {
  return instance.post(`/seller/pub/owner`, request);
}

export function updatePubOwnerApi(
  id: number,
  request: PubOwnerAccessRequest,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub/owner/${id}`, request);
}

export function deletePubOwnerApi(
  userId: number,
  pubId: number,
): Promise<{ code: number; message: string }> {
  return instance.delete(`/seller/pub/owner/${userId}/${pubId}`);
}

export function activePubOwnerApi(
  id: number,
  active: boolean,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub/owner/${id}/active?active=${active}`);
}
